import type { CreatorSummary } from '../types';
import { getCreators } from './creators-api';
import type { EarningsDto } from './creators-api.types';
import { mapEarningsDto } from './dashboard.mapper';

/** The creator's code, earnings and withdrawal state, for the whole dashboard. */
export async function fetchCreatorSummary(): Promise<CreatorSummary> {
	return mapEarningsDto(await getCreators<EarningsDto>('earnings'));
}
